import { getAuthHeaders, createApiError } from "../utils/servicesUtils";
import { apiFetch } from "../utils/apiFetch";

export const getMyPolicyConsentStatus = async () => {
  const ENDPOINT = `/api/policy/me/status`;
  const pending = localStorage.getItem("pending_token");
  const headers = getAuthHeaders(pending || null);

  const response = await apiFetch(ENDPOINT, { headers }, { skipAuthHandling: true });
  if (!response.ok) {
    throw await createApiError(response, "Failed to fetch policy consent status");
  }
  return response.json();
};

export const submitMyPolicyConsent = async (payload = {}) => {
  const ENDPOINT = `/api/policy/me/consent`;
  const pending = localStorage.getItem("pending_token");
  const headers = getAuthHeaders(pending || null);

  const response = await apiFetch(
    ENDPOINT,
    {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    },
    { skipAuthHandling: true }
  );

  if (!response.ok) {
    throw await createApiError(response, "Failed to submit policy consent");
  }

  return response.json().catch(() => ({}));
};